'use strict';

/* eslint angular/prefer-component:0 */

(function () {
	angular.module('natiwi.navigation-menu').directive('nwNavSubmenu', [function () {
		return {
			restrict: 'E',
			transclude: true,
			replace: true,
			require: ['^nwNavMenu'],
			// scope: true,
			bindToController: true,
			template: '<ul class="cd-secondary-dropdown is-hidden" ng-transclude></ul>'
		};
	}]);
})();